import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { Employee } from 'src/core/employee.model';
import { Http } from '@angular/http';
import { CompanyService } from '../company.service';
@Injectable({
  providedIn: 'root'
})
export class EmployeeServiceService {
  getEmployees = '/api/AndroidAPI_server/getemployees.php';
  
  constructor(
    public http: Http,
    public companyService: CompanyService
  ) {}

  async getUsers(): Promise<any> {
    const body = {
      comcde: await this.companyService.getComcde()
    }
    return await this.http.post(this.getEmployees, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }
}
